import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import { workflowLWDsApi } from './workflowLWDsSlice';
import { throwErrorToast, getOAuth2StartUrl } from 'utils';
import { errorMessages } from 'constants/messages';

export const workflowLWDApiQueryErrorLogger: Middleware = () => next => action => {
    if (action.type.split('/')[0] === workflowLWDsApi.reducerPath && isRejectedWithValue(action)) {
        const firstErrorKey = action?.payload?.data?.Errors && Object.keys(action?.payload?.data?.Errors)?.[0];
        const containsNoHTML = typeof action?.payload?.data === 'string' && !/<.*?>/.test(action?.payload?.data);

        const errorMessage = (errorCode: number) =>
            containsNoHTML
                ? action?.payload?.data
                : firstErrorKey
                ? action.payload.data.Errors[firstErrorKey]
                : typeof action?.payload?.data?.detail === 'string'
                ? action.payload.data.detail
                : action?.payload?.data?.Title
                ? action.payload.data.Title
                : action?.payload?.data?.errors
                ? action.payload.data.errors
                : typeof action?.payload?.status === 'string'
                ? action.payload.status
                : `${errorMessages[errorCode]}: ${errorCode}`;

        switch (action?.payload?.originalStatus || action?.payload?.status) {
            case 400:
                throwErrorToast({
                    message: action?.payload?.data?.message ?? errorMessages[400],
                    action,
                    errorCode: 400,
                });
                break;

            case 401:
                throwErrorToast({
                    message: errorMessage(401),
                    action,
                    errorCode: 401,
                });
                location.replace(getOAuth2StartUrl());
                break;

            case 403:
                console.warn(`Type: ${action.type}`);
                console.warn(`We got a rejected action in API! (ERROR CODE 403) - ${action.meta.arg.endpointName}`);
                console.warn(action.payload);
                break;

            case 404:
                throwErrorToast({
                    message: errorMessage(404),
                    action,
                    errorCode: 404,
                });
                break;

            case 409:
                throwErrorToast({
                    message: errorMessage(409),
                    action,
                    errorCode: 409,
                });
                break;

            case 500:
                throwErrorToast({
                    message: errorMessage(500),
                    action,
                    errorCode: 500,
                });
                break;

            default:
                throwErrorToast({
                    message: errorMessage(500),
                    action,
                    errorCode: 500,
                });
                break;
        }
    }

    return next(action);
};
